import type { ProcurementSubjectType } from '../api/lots';

export const SUBJECT_GROUPS = { 1: 'goods', 2: 'works', 3: 'services' } as const;

/** Procurement subject is independent of the ENS TRU catalog navigation group. */
export function readProcurementSubject(value: string | null): ProcurementSubjectType | undefined {
  return value === '1' ? 1 : value === '2' ? 2 : value === '3' ? 3 : undefined;
}
